import type { IconProps } from './icon.types'

const ChevronDownIcon = (props: IconProps) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='chevron-down-icon'
    {...props}
  >
    <path d='M4.5 7 9 11.5 13.5 7' />
  </svg>
)

export default ChevronDownIcon
